import { CreativeListRecord, CreativeType } from 'core/creative/Creative';
import { ImageCreativeDetail } from './ImageCreativeDetail';
import { ProductNativeCreativeDetail } from './ProductNativeCreativeDetail';
import { RichProductNativeCreativeDetail } from './RichProductNativeCreativeDetail';
import { WebRichProductNativeCreativeDetail } from './WebRichProductNativeCreativeDetail';
import { RichMediaCreativeDetail } from './RichMediaCreativeDetail';

const detailComponentSettings = {
  [CreativeType.IMAGE]: ImageCreativeDetail,
  [CreativeType.PRODUCT_NATIVE]: ProductNativeCreativeDetail,
  [CreativeType.RICH_PRODUCT_NATIVE]: RichProductNativeCreativeDetail,
  [CreativeType.WEB_RICH_PRODUCT_NATIVE]: WebRichProductNativeCreativeDetail,
  [CreativeType.BRAND_LED]: WebRichProductNativeCreativeDetail,
  [CreativeType.SITE_WIDE_RECOMMENDED]: ProductNativeCreativeDetail,
  [CreativeType.PERSONALIZED_GOLDEN_RECOMMENDED]: ProductNativeCreativeDetail,
  [CreativeType.RICH_MEDIA]: RichMediaCreativeDetail
};

export interface CreativeDetailModel {
  creative: CreativeListRecord;
  detailComponent: any;
}

export type CreativeDetailProps = {
  model: CreativeDetailModel
};

export class DefaultCreativeDetailModel implements CreativeDetailModel {

  creative: CreativeListRecord;
  detailComponent: any;

  constructor (creative: CreativeListRecord) {
    this.creative = creative;
    this.detailComponent = detailComponentSettings[this.creative.creativeType];
  }
}
